
export class Report9BoxText {    
    public contentKey: string;
    public value: string;
    public languageId: number;
}

export class Report9BoxSettings {
    public id: number;
    public box1Color: string;
    public box2Color: string;
    public box3Color: string;
    public box4Color: string;
    public box5Color: string;
    public box6Color: string;
    public box7Color: string;
    public box8Color: string;
    public box9Color: string;
    public report9BoxTexts: Report9BoxText[];
}


// WEBPACK FOOTER //
// ./src/models/Report9BoxSettings.tsx